module.exports = __webpack_public_path__ + "static/media/solution-strategy-icon.9e7a1390.svg";